import { render, staticRenderFns } from "./self-care-a45.vue?vue&type=template&id=333214d0&"
import script from "./self-care-a45.vue?vue&type=script&lang=js&"
export * from "./self-care-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports